import { z } from 'zod';
import { platformApprovedActionProviderDescriptorV2Schema, platformApprovedActionProviderRequestV2Schema, platformApprovedActionProviderResultV2Schema, platformApprovedActionProviderSlot, platformReceiptBoundActionProviderHostCapability, } from '@crest/platform-contracts/hosts';
export const projectsAssistantTeamActionProviderId = 'projects.assistant-team-actions';
export const projectsAssistantTeamActionProviderCapability = 'projects.assistant-team-actions.v1';
export const projectsAssistantTeamActionSlot = platformApprovedActionProviderSlot;
export const projectsAssistantProjectTeamAssignmentActionId = 'projects.project-team-assignment.v1';
export const projectsAssistantProjectTeamAssignmentInputSchema = z.strictObject({
    targetProjectId: z.string().uuid(),
    membershipId: z.string().uuid(),
    role: z.enum(['tech', 'lead_tech', 'sales_rep']),
});
export const projectsAssistantProjectTeamAssignmentInputSchemaHash = '39b16ff561502c9d2ea7106c7aa48cbd6ba290770b1d41dd4bdeb9075fda6bc4';
export const projectsRemoveAssistantCreatedProjectTeamAssignmentActionId = 'projects.remove-assistant-created-project-team-assignment.v1';
export const projectsRemoveAssistantCreatedProjectTeamAssignmentInputSchema = z.strictObject({
    targetAssignmentId: z.string().uuid(),
    originalExecutionId: z.string().uuid(),
    expectedRevision: z.number().int().positive().max(2_147_483_646),
    reason: z.string().trim().min(5).max(2_000),
    compensationSummary: z.string().trim().min(1).max(500),
});
export const projectsRemoveAssistantCreatedProjectTeamAssignmentInputSchemaHash = 'b5699c29af944ad55f03f362f499bbd0fe948d30ac4e295c72bcc6e323078c42';
export const projectsAssistantTeamActionProviderDescriptor = platformApprovedActionProviderDescriptorV2Schema.parse({
    kind: 'descriptor',
    contractVersion: platformReceiptBoundActionProviderHostCapability,
    providerId: projectsAssistantTeamActionProviderId,
    providerCapability: projectsAssistantTeamActionProviderCapability,
    displayName: 'Projects approved team actions',
    actions: [{
            actionId: projectsAssistantProjectTeamAssignmentActionId,
            displayName: 'Assign Project team membership',
            targetResourceType: 'projects.project',
            inputSchemaHash: projectsAssistantProjectTeamAssignmentInputSchemaHash,
            requiredPermission: 'projects.team.assign',
            assistantPolicy: {
                policyContractVersion: 'platform.assistant-action-policy.v1',
                confirmation: 'explicit',
                effectClass: 'compensating-write',
                externalEffectClass: 'none',
                reversal: {
                    kind: 'compensating-action',
                    registeredReversalActionId: projectsRemoveAssistantCreatedProjectTeamAssignmentActionId,
                },
                ownerReadbackRequired: true,
                inputSchemaHash: projectsAssistantProjectTeamAssignmentInputSchemaHash,
            },
        }, {
            actionId: projectsRemoveAssistantCreatedProjectTeamAssignmentActionId,
            displayName: 'Remove Assistant-created Project team assignment',
            targetResourceType: 'projects.project-team-assignment',
            inputSchemaHash: projectsRemoveAssistantCreatedProjectTeamAssignmentInputSchemaHash,
            requiredPermission: 'projects.team.assign',
            assistantPolicy: {
                policyContractVersion: 'platform.assistant-action-policy.v1',
                confirmation: 'explicit',
                effectClass: 'compensating-write',
                externalEffectClass: 'none',
                reversal: { kind: 'compensating-action', registeredReversalActionId: null },
                ownerReadbackRequired: true,
                inputSchemaHash: projectsRemoveAssistantCreatedProjectTeamAssignmentInputSchemaHash,
            },
        }],
});
export const projectsAssistantTeamActionProviderRequestSchema = platformApprovedActionProviderRequestV2Schema;
export const projectsAssistantTeamActionProviderResultSchema = platformApprovedActionProviderResultV2Schema;
//# sourceMappingURL=projects-assistant-team-actions.contract.js.map